import script from "./toolbar-button-human-service.vue?vue&type=script&lang=ts&setup=true"
export * from "./toolbar-button-human-service.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__